import PythonApi from '@/services/PythonApi';

export default {
  list(fromDate, toDate, cowIDs, bolusIds, limit) {
    const params = new URLSearchParams();
    if (fromDate) params.append('from_date', fromDate);

    if (toDate) params.append('to_date', toDate);

    if (cowIDs && cowIDs.length)
      cowIDs.forEach(cow_id => params.append('cow_ids', cow_id));

    if (bolusIds && bolusIds.length)
      bolusIds.forEach(bolus_id => params.append('bolus_ids', bolus_id));

    if (limit)
      params.append('limit', limit);

    return PythonApi().get('sensorLog', params);
  },

  debugList(fromDate, toDate, cowIDs, bolusIds, limit, abnormalOnly) {
    const params = new URLSearchParams();
    if (fromDate) params.append('from_date', fromDate);

    if (toDate) params.append('to_date', toDate);

    if (cowIDs && cowIDs.length)
      cowIDs.forEach(cow_id => params.append('cow_ids', cow_id));

    if (bolusIds && bolusIds.length)
      bolusIds.forEach(bolus_id => params.append('bolus_ids', bolus_id));

    if (abnormalOnly)
      params.append('abnormal_only', abnormalOnly);

    if (limit)
      params.append('limit', limit);

    return PythonApi().get('sensorLog/debug', params);
  },

  async getLatestSensorLogs(for_bolus) {
    const params = new URLSearchParams();
    if (for_bolus) params.append('for_bolus', for_bolus);
    return PythonApi().get("sensorLog/last", params);
  },

  async getHighTempInfo() {
    return PythonApi().get("sensorLog/high_temp_info");
  },

  thiList(fromDate, toDate, thiSensorIDs, limit) {
    const params = new URLSearchParams();
    if (fromDate) params.append('from_date', fromDate);

    if (toDate) params.append('to_date', toDate);

    if (thiSensorIDs && thiSensorIDs.length)
      thiSensorIDs.forEach(id => params.append('thi_sensor_ids', id));

    if (limit)
      params.append('limit', limit);

    return PythonApi().get('sensorLog/thi', params);
  }
};



// WEBPACK FOOTER //
// ./src/api/sensor-log-api.js